export class DowntimeMachineNameRequest{
    assetCode?:string;
    assetCategoryId?:number;
}